import { RecordNotifications } from './RecordNotifications.main';
import { SettingUpAutomaticMessagingToClients } from './SettingUpAutomaticMessagingToClients.main';

export { RecordNotifications, SettingUpAutomaticMessagingToClients };
